
import { useNavigate } from "react-router-dom";
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useGalponesStore } from "../../../../store";
import { AlertScreen } from "../../components/AlertScreen";
import { envVariables } from "../../../../helpers";

const paginado = Number( envVariables.REACT_APP_PAGINADO);




export const TablaListGalpones = ({ data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalGalpon } = useGalponesStore();


    const handleOpcionesGalpon = (id) => {
        navigate(`/admin/opcion/${id}/galpon`)
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'22%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'17%'}}>GRANJA</TableCell>
                                <TableCell sx={{width:'12%'}}>CANTIDAD</TableCell>
                                <TableCell sx={{width:'13%'}}>ALTO</TableCell>
                                <TableCell sx={{width:'13%'}}>LARGO</TableCell>
                                <TableCell sx={{width:'12%'}}>ANCHO</TableCell>
                                <TableCell sx={{width:'12%'}}>AREA</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map( (galpon) => (
                            <TableRow key={ galpon.id } onClick={ () => handleOpcionesGalpon(galpon.id) } sx={{cursor:'pointer'}}>
                                <TableCell >{ galpon.nombre }</TableCell>
                                <TableCell>{ galpon.granja?.nombre }</TableCell>
                                <TableCell>{ galpon.cantidad }</TableCell>
                                <TableCell>{ galpon.alto }</TableCell>
                                <TableCell>{ galpon.largo }</TableCell>
                                <TableCell>{ galpon.ancho }</TableCell>
                                <TableCell>{ galpon.area }</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalGalpon / paginado)} disabled={Math.ceil(totalGalpon / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay galpones creados por el momento..."/>
        }
        </>
    )
}
